interface Props {
    id: string;
}

// this is debatable, and maybe I should strip it out of production builds
// I'm only using this for pages at the moment
// to give something for playwright to look for when a page loads
export const DataTestId = ({ id }: Props): React.ReactElement => <div data-testid={id} />;
